module.exports = __webpack_public_path__ + "img/gift-content-zh.f163cfd0.png";